import { z } from 'zod';

export const schemaConsorsEmployerName = z
    .string()
    .min(0)
    .max(60)
    .regex(/^[^<>?!#$%^]*$/, 'Invalid characters');
